import axios from "axios";
import { APP_VERSION as GENERATED_APP_VERSION } from "../generated/version";

export const SUCCESS = true;
export const FAILURE = false;

/**
 * @type {'PROD' | 'HOMOLOG' | 'DEV'}
 */
const LOCAL_ENV = "PROD";

export const APP_VERSION = GENERATED_APP_VERSION;

export const ENV = LOCAL_ENV;

const getServerURL = (env) => {
    switch (env) {
        case "PROD":
            return 'https://unoapp.com.br/server/'
        case "DEV":
            return 'http://localhost:5001/'
        case "HOMOLOG":
            return 'http://ec2-54-94-136-127.sa-east-1.compute.amazonaws.com/server/'
    }
}

const SERVER_URL = getServerURL(ENV);
export const LOGOS_URL = ENV === 'PROD' ? "https://uno-prod-files.s3.sa-east-1.amazonaws.com/" + 'logos/' : "";
const SERVER_API = SERVER_URL + 'api/v1';

export const REPORTS_URL = SERVER_URL;

export const UNO_V2_URL = 'https://v2.unoapp.com.br';

export default axios.create({

    baseURL: SERVER_API,

    responseType: "json"

});

export const isDevENV = ENV === "DEV";

export const defaultConfig = {
    headers: {
        'x-access-token': localStorage.getItem('token'),
    }
}